import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import _ from 'lodash';
import Dialog from '../../../../../components/Dialog';
import Text from '../../../../../components/Text';
import StyleInput from '../../../../../components/StyleInput';
import { SatelliteStoreEmailAlert } from '../EmailAlert';
import { getUUID } from '../../../../../utils';
import { i18n } from '../../../../../language';

const CentralStoreThresholdPopup = ({
  formData,
  handleClose,
  formChangeHandler,
  setRecipientsListPopup,
  checkChange,
  wardsOptions,
}) => {
  const initSatelliteStoreThresholds = () => {
    let thresholdList = [];
    const groupSatelliteStoreByWard = _.groupBy(formData?.satelliteStores, 'wardId');
    _.forEach(groupSatelliteStoreByWard, (val, key) => {
      let keyToNumber = parseInt(key);
      const wardName = _.find(wardsOptions, (ward) => ward?.value === keyToNumber)?.text;
      const centralStoreThreshold = {
        name: wardName,
        wardId: keyToNumber,
        alertUrgentThreshold:
          _.find(formData?.wardThreshold, (item) => item?.wardId === keyToNumber)?.alertUrgentThreshold ?? 0,
        isCentralStore: true,
        id: getUUID(),
      };
      // 如果satelliteStoresName为空，则不显示该条
      const satelliteStoreThresholdList = _.compact(
        _.map(val, (item) => {
          // if (!item?.satelliteStoresName) {
          //   return null;
          // }
          return {
            ...item,
            alertUrgentThreshold: item?.satelliteStoresAlertThreshold,
            name: `${wardName}-${item?.satelliteStoresName}`,
            id: getUUID(),
          };
        })
      );
      thresholdList = thresholdList.concat([centralStoreThreshold, ...satelliteStoreThresholdList]);
    });
    return thresholdList;
  };
  const initCentralStoreThresholds = () => {
    return _.map(formData?.wardIds, (item) => ({
      wardId: item?.value,
      alertUrgentThreshold:
        _.find(formData?.wardThreshold, (wardItem) => wardItem?.wardId === item?.value)?.alertUrgentThreshold ?? 0,
      id: getUUID(),
      name: _.find(wardsOptions, (ward) => ward?.value === item?.value)?.text,
    }));
  };
  const handleInit = () => {
    if (formData?.loanModel === 1) {
      return initCentralStoreThresholds();
    } else {
      return initSatelliteStoreThresholds();
    }
  };

  const [thresholdList, setThresholdList] = useState(handleInit());

  const handleUpdate = (val, id) => {
    setThresholdList((prev) => {
      return _.map(prev, (item) => {
        if (item?.id === id) {
          return { ...item, alertUrgentThreshold: val };
        }
        return item;
      });
    });
  };

  const centralStoreConfirm = () => {
    const centralStoreThresholdList = _.map(thresholdList, (item) => ({
      wardId: item?.wardId,
      alertUrgentThreshold: parseInt(item?.alertUrgentThreshold),
    }));
    formChangeHandler('wardThreshold')(centralStoreThresholdList);
  };
  const satelliteStoreConfirm = () => {
    const centralStores = _.filter(thresholdList, (item) => item?.isCentralStore);
    const centralStoreThresholdList = _.map(centralStores, (item) => ({
      wardId: item?.wardId,
      alertUrgentThreshold: parseInt(item?.alertUrgentThreshold),
    }));
    formChangeHandler('wardThreshold')(centralStoreThresholdList);

    const satelliteStores = _.filter(thresholdList, (item) => !item?.isCentralStore);
    const satelliteStoresThresholdList = _.map(satelliteStores, (item) => ({
      adsLocation: item.adsLocation,
      categorySatelliteStoresId: item.categorySatelliteStoresId,
      satelliteStoresName: item.satelliteStoresName,
      thresholdSettingsDay: item.thresholdSettingsDay,
      wardId: item.wardId,
      satelliteBoundDevice: Boolean(item.satelliteBoundDevice),
      satelliteStoresAlertThreshold: parseInt(item?.alertUrgentThreshold),
    }));
    formChangeHandler('satelliteStores')(satelliteStoresThresholdList);
  };
  const confirmAction = () => {
    if (formData?.loanModel === 1) {
      centralStoreConfirm();
    } else {
      satelliteStoreConfirm();
    }
    handleClose();
  };

  return (
    <Dialog
      open={true}
      title="Central Stores List"
      cancel="Cancel"
      confirm="Confirm"
      dialogfootStyle={{ marginTop: '0', paddingTop: '1rem', borderTop: '1px solid #E6E9F2' }}
      width="auto"
      handleClose={handleClose}
      handleCancel={handleClose}
      handleConfirm={confirmAction}
    >
      <Box mb="1.56rem">
        {/* <SatelliteStoreEmailAlert
          formData={formData}
          setRecipientsListPopup={setRecipientsListPopup}
          checkChange={checkChange}
        /> */}
        <Box display="flex" gridGap="0.714rem" mb="0.785rem">
          <Box width="20rem">
            <Text color="#2E4469" fontSize="1.142rem">
              {formData?.loanModel === 1 ? 'Central Store' : 'Central & Satellite Store'}
            </Text>
          </Box>
          <Box width="25rem">
            <Text color="#2E4469" fontSize="1.142rem">
              {i18n.t('SETTING_EQUIPMENT_ALERT_DEVICE_COUNT')}
            </Text>
          </Box>
        </Box>
        <Box>
          {thresholdList?.map((thresholdItem, index) => (
            <Box
              display="flex"
              gridGap="0.714rem"
              mt={index === 0 ? '0rem' : '1.142rem'}
              key={`threshold-${index}-${thresholdItem.wardId}`}
            >
              <Box display="flex" width="20rem" alignItems="center">
                <Text color="#1973E6" fontSize="1.5rem">
                  {thresholdItem.name}
                </Text>
              </Box>
              {/* <StyleInput disabled={true} width="25rem" value={thresholdItem.name} /> */}
              <StyleInput
                disabled={!formData?.emailAlertEnableYn}
                width="25rem"
                value={thresholdItem.alertUrgentThreshold}
                inputProps={{ type: 'number' }}
                onChange={(val) => handleUpdate(val, thresholdItem.id)}
              />
            </Box>
          ))}
        </Box>
      </Box>
    </Dialog>
  );
};

export default CentralStoreThresholdPopup;
